import { RailsuiToast } from "railsui-stimulus";

export default class extends RailsuiToast {
  connect() {
    super.connect();

    if (this.triggerOnLoadValue) {
      console.log("triggerOnLoadValue", this.triggerOnLoadValue);

      setTimeout(() => {
        this.toggleTransition();
      }, 3000);
    }
  }
}
